import { useEffect } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../stores/useStores';

import classes from './DailyBonus.module.scss';

function msToTimeString(ms: number): string {
  // Calculate hours, minutes and seconds
  const hours = Math.floor(ms / 3600000); // 1 Hour = 3600000 Milliseconds
  const minutes = Math.floor((ms % 3600000) / 60000); // 1 Minute = 60000 Milliseconds
  const seconds = Math.floor((ms % 60000) / 1000); // 1 Second = 1000 Milliseconds

  // Format time string
  const timeString = `${hours
    .toString()
    .padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return timeString;
}

const BonusFooter = observer(() => {
  const { rewardsStore } = useStores();
  const { t } = useTranslation();
  const ms = rewardsStore.dailyBonus?.timeUntilNextBonusMS || 0;
  useEffect(() => {
    // Sync immediately on mount, not a second later: the countdown is only recomputed while
    // this component is alive, so on open it still holds whatever was last written. Letting
    // the first interval tick absorb that gap reads as the timer jumping.
    rewardsStore.countDownBonusTime();

    const intval = setInterval(() => {
      rewardsStore.countDownBonusTime();
    }, 1000);
    return () => {
      clearInterval(intval);
    };
  }, [rewardsStore]);

  if (rewardsStore.dailyBonus?.isEntitledToBonus || ms === 0) {
    return <div className={classes.description}>{t('bonus.tapToCollect')}</div>;
  }

  return (
    <div className={classNames(classes.countdown, 'uppercase')}>
      <span>{t('bonus.nextIn')}&nbsp;</span>
      {msToTimeString(ms)}
    </div>
  );
});

export default BonusFooter;
